module.exports = __webpack_public_path__ + "img/3.efc04780.png";